import { apiCall } from '../../services/apiUtil';

/**
 * Subscription API
 *
 * Current plan info and Stripe Customer Portal access for the logged-in user.
 */
export const subscriptionAPI = {
  /**
   * Get the current user's subscription/plan info.
   * @returns {Promise} { valid, planName, displayType, status, validUntil, isTrial, trialEndsAt, isDefault, displayPrice, interval }
   */
  getCurrent: async () => {
    return apiCall('/subscription');
  },

  /**
   * Create a Stripe Customer Portal session for the current user.
   * @returns {Promise} { url } - redirect the browser here to manage/upgrade/downgrade
   */
  getPortalUrl: async () => {
    return apiCall('/subscription/portal-session', { method: 'POST' });
  },
};

export default subscriptionAPI;
